import React, { useEffect, useState } from "react";
import * as S from "./styles";
import * as dateFns from "date-fns";
import { Checkbox, CircularProgress, Grid } from "@mui/material";
import { api } from "@/services/api";
import { UserPaymentRequest } from "@/interfaces/user";
import { toast } from "react-toastify";
import { Controller, useForm } from "react-hook-form";
import { FutButton } from "@/components/FutButton";
import FutSelect from "@/components/FutSelect";
import { paymentsTypes } from "./data";

type statusType = "PENDENTE" | "APROVADO" | "PAGO" | "RECUSADO";

const realFormatter = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

export default function Payments() {
  const [paymentData, setPaymentData] = useState<UserPaymentRequest[]>([]);
  const [loading, setLoading] = useState(false);

  const payForm = useForm({
    defaultValues: {
      usersIds: [] as string[],
      isPending: true,
    },
  });

  const watchIsPending = payForm.watch("isPending");

  const getPayments = async (status: statusType) => {
    try {
      setLoading(true);
      const res = await api.get("/payment/pending-requests", {
        params: {
          status,
        },
      });

      const data = res.data.body.data as UserPaymentRequest[];

      setPaymentData(data);

      setLoading(false);
    } catch (e) {
      toast.error(e as any);
      setLoading(false);
    }
  };
  useEffect(() => {
    getPayments("PENDENTE");
  }, []);

  const handleCheckboxes = (item: string) => {
    const oldArray = payForm.getValues("usersIds");

    const newArray = [...oldArray];

    const index = newArray.findIndex((x) => x === item);

    if (index === -1) {
      newArray.push(item);
      return newArray;
    }

    newArray.splice(index, 1);
    return newArray;
  };

  const handleSelectAll = () => {
    const allIds = paymentData.map(el => el.id.toString())

    payForm.setValue("usersIds", allIds)
  }

  const judgePayments = async (decision: "APPROVE" | "REJECT") => {
    const stringIds = payForm.getValues("usersIds");
    if (!stringIds.length) {
      return;
    }

    if (
      window.confirm(
        `Você realmente deseja ${
          decision === "APPROVE" ? "APROVAR" : "REJEITAR"
        } estes usuários?`
      )
    ) {
      try {

        const ids = stringIds.map((el) => parseInt(el));
        
        await api.post("/payment/judge-requests", {
          ids,
          decision,
        });

        const copyPaymentData = [...paymentData];
        
        ids.map((id) => {
        const index = copyPaymentData.findIndex((payment) => id === payment.id);
        
        copyPaymentData.splice(index, 1);
        
        return;
      });
      
      setPaymentData(copyPaymentData);

      toast.success("Ação realizada com sucesso!")
    } catch(e) {
      toast.error("Ocorreu um erro ao tentar fazer os pagamento")
    }
    }
  };

  return (
    <>
      <S.ActionsWrapper>
        <FutSelect
          data={paymentsTypes}
          //@ts-ignore
          onChange={(e) => {
            getPayments(e.target.value as statusType);
            if (e.target.value === "PENDENTE") {
              payForm.setValue("isPending", true);
              return;
            }
            payForm.setValue("isPending", false);
          }}
          defaultValue={paymentsTypes[0].value}
        />
        <FutButton
          disabled={!watchIsPending}
          onClick={() => judgePayments("APPROVE")}
        >
          Confirmar
        </FutButton>
        <FutButton
          variant="text"
          color="error"
          disabled={!watchIsPending}
          onClick={() => judgePayments("REJECT")}
        >
          Rejeitar
        </FutButton>
      </S.ActionsWrapper>
      {loading ? (
        <Grid container justifyContent="center">
          <CircularProgress />
        </Grid>
      ) : paymentData.length ? (
        <S.PaymentWrapper>
          <S.PaymentTable>
            <thead>
              <tr>
                <th>
                  <FutButton
                    sx={{ padding: "0 3px",my: 1 }}
                    disabled={!watchIsPending}
                    variant="text"
                    onClick={handleSelectAll}
                  >
                    Selecionar Todos
                  </FutButton>
                </th>
                <th>Nome</th>
                <th>E-mail</th>
                <th>Telefone</th>
                <th>Data do pedido</th>
                <th>Valor do saque</th>
              </tr>
            </thead>
            <tbody>
              {paymentData.map((el) => (
                <tr key={el.id}>
                  <td>
                    <Controller
                      name="usersIds"
                      control={payForm.control}
                      disabled={!watchIsPending}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          checked={field.value.some(
                            (x) => x === el.id.toString()
                          )}
                          onChange={() =>
                            field.onChange(handleCheckboxes(el.id.toString()))
                          }
                        />
                      )}
                    />
                  </td>
                  <td>{el.user.name}</td>
                  <td>{el.user.email}</td>
                  <td>{el.user.phone}</td>
                  <td>
                    {dateFns.format(
                      dateFns.parseISO(el.payment_date),
                      "dd/MM/yyyy"
                    )}
                  </td>
                  <td>{realFormatter.format(el.amount)}</td>
                </tr>
              ))}
            </tbody>
          </S.PaymentTable>
        </S.PaymentWrapper>
      ) : (
        <S.NotFound>
          <p>0 Resultados Encontrados</p>
        </S.NotFound>
      )}
    </>
  );
}
